module.exports = __webpack_public_path__ + "img/empty-4.1d5be7e6.svg";